import axios from 'axios';

import { assertClientSide } from '@dr.pogodin/react-utils';

import { P_API_RESEARCH_LIB_LINKS, getConfig } from 'utils';

export async function removeResearchLibLink(linkId: string): Promise<void> {
  assertClientSide();

  const config = await getConfig();

  await axios.delete(
    `${P_API_RESEARCH_LIB_LINKS}/${linkId}`,
    { headers: { 'csrf-token': config.CSRF } },
  );
}
